// extracted by mini-css-extract-plugin
export default {"sush":"BackImageText_sush__eAXwo"};